<div
  class="offer-card offer-card-body px-2 h-100 d-flex flex-column"
  [class.rounded-top-0]="isBestChoice()"
  [class.border-top-0]="isBestChoice()"
>
  <span class="offer-card-header__title mb-0">{{ title() }}</span>
  <span>{{ description() }}</span>
  <button
    class="btn p-0 border-0 btn-link my-3 w-fit"
    (click)="showExplanation.emit('variable')"
    wlAutomationId="info-card-button"
    wlCSCapture
  >
    {{ explanationButtonTitle() }}
  </button>
  <crnt-button
    class="w-75"
    [variant]="'secondary'"
    (click)="selectOffer.emit()"
    wlCSCapture
    wlAutomationId="offer-submit-button"
  >
    {{ buttonTitle() }}
  </crnt-button>
</div>
